import { extractWebsite } from '@hivebrite/design-system/Embed';

import { getAspectRatio } from './getAspectRatio';

/** Checks wether the URL is an embedly URL */
const embedlyUrlPattern = /cdn.embedly.com/;

/** Identifies the embed source URL in the embedly URL
 * - capture group 1: source url
 */
const urlPattern = /url=([^&]+)/;

/** Identifies the provider name in the embedly URL.
 * - capture group 1: display name of the provider
 */
const displayNamePattern = /display_name=([^&]+)/;

export const extractConsentGuardProps = (iframe: HTMLIFrameElement) => {
  const isEmbedly = embedlyUrlPattern.test(iframe.src);

  let sourceUrl = iframe.src;
  let providerName = '';

  // For embedly content, we need to extract the source URL and provider name
  // from the iframe URL
  if (isEmbedly) {
    const encodedSourceUrl = sourceUrl.match(urlPattern)?.[1] ?? '';

    sourceUrl = decodeURIComponent(encodedSourceUrl);
    providerName = iframe.src.match(displayNamePattern)?.[1] ?? '';
  }

  const hostName = extractWebsite(sourceUrl) || '';
  const aspectRatio = getAspectRatio(iframe);

  providerName ||= hostName;

  return {
    hostName,
    providerName,
    aspectRatio,
  };
};
